Namespace('Settings.Views.ChatbotConfiguration')

class Settings.Views.ChatbotConfiguration.ChatbotsSelectView extends Backbone.View
  template: JST['backbone/templates/settings/chatbot_configuration/chatbots_select']
  className: 'chatbot-configuration-chatbots-select mx-4 mt-4'

  noChatbotSelected : 'no-chatbot-selected'

  initialize: (chatbots) ->
    @chatbots = chatbots
    @chatbotCode = @noChatbotSelected

  render: =>
    @$el.html(@template(chatbots: @chatbots, selectedChatbotCode: @chatbotCode, noChatbotSelected: @noChatbotSelected))
    @$el.find('select').chosen(width: '200px').change (event) =>
      @chatbotCode = event.target.value
      @trigger('change', chatbotCode: @chatbotCode)
    @

  isChatbotSelected: =>
    @chatbotCode && @chatbotCode != @noChatbotSelected
